import React from "react";
import { Box, Typography } from "@mui/material";
import EmployeeAttendance from "./EmployeeAttendance";
import EmployeeAllocation from "./EmployeeAllocation";
import OTAllocated from "./OTAllocated";
import OTNonAllocated from "./OTNonAllocated";
import AllocationDiscrepancy from "./AllocationDiscrepancy";
import AttendanceAdmin from "./AttendanceAdmin";
import EwoDiscrepancy from "./EwoDiscrepancy";
import DesignationBased from "./DesignationBased";

// Map of sub-tab IDs to components
const VIEW_MAP = {
  20: { label: "Employee Attendance",      component: <EmployeeAttendance /> },
  21: { label: "Employee Allocation",      component: <EmployeeAllocation /> },
  22: { label: "OT Allocated",             component: <OTAllocated /> },
  23: { label: "OT Non Allocated",         component: <OTNonAllocated /> },
  24: { label: "Allocation Discrepency",   component: <AllocationDiscrepancy /> },
  25: { label: "Attendance Admin",         component: <AttendanceAdmin /> },
  26: { label: "EWO Discrepency",          component: <EwoDiscrepancy /> },
  27: { label: "Designation Based",        component: <DesignationBased /> },
};

export default function AttendanceManagement({ activeSubTab = 20 }) {
  const current = VIEW_MAP[activeSubTab] || VIEW_MAP[20];

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        bgcolor: "#F4F6FA",                                          // #f8faff → #F4F6FA
        backgroundImage: "radial-gradient(rgba(30,58,110,0.06) 1px, transparent 1px)",  // rgba(0,74,173) → rgba(30,58,110)
        backgroundSize: "28px 28px",
        p: { xs: 2, md: 3 },
      }}
    >
      {/* Section Header */}
      <Box sx={{ mb: 2.5, display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box
          sx={{
            width: 4,
            height: 28,
            borderRadius: "4px",
            background: "linear-gradient(180deg, #330066 0%, #4A6FA5 100%)",  // #330066 → #330066, #3b82f6 → #4A6FA5
          }}
        />
        <Typography
          sx={{
            fontSize: { xs: "1.1rem", sm: "1.3rem" },
            fontWeight: 700,
            background: "linear-gradient(135deg, #330066 0%, #4A6FA5 100%)",  // #330066 → #330066, #3b82f6 → #4A6FA5
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: "0.3px",
          }}
        >
          {current.label}
        </Typography>
      </Box>

      {/* Active Sub-View */}
      <Box
        sx={{
          p: { xs: 2, md: 3 },
          borderRadius: "20px",
          border: "1px solid rgba(30,58,110,0.1)",                   // rgba(0,74,173) → rgba(30,58,110)
          bgcolor: "#ffffff",
          boxShadow: "0 4px 24px rgba(30,58,110,0.06)",              // rgba(0,74,173) → rgba(30,58,110)
        }}
      >
        {current.component}
      </Box>
    </Box>
  );
}